import { LoanProductCategory } from '@mediaingenuity/totallymoney.types'

type LoanCategoryPath =
    | 'all'
    | 'bad-credit'
    | 'guarantor'
    | 'car-finance'
    | 'homeowner'
    | 'alternative-products'

export const categories: Record<
    LoanProductCategory,
    { name: string; path: LoanCategoryPath }
> = {
    ['PersonalLoan']: {
        path: 'all',
        name: 'All Loans',
    },
    ['PoorCredit']: {
        path: 'bad-credit',
        name: 'Bad Credit',
    },
    ['Guarantor']: {
        path: 'guarantor',
        name: 'Guarantor',
    },
    ['CarFinance']: {
        path: 'car-finance',
        name: 'Car Finance',
    },
    ['Secured']: {
        path: 'homeowner',
        name: 'Homeowner',
    },
    ['AlternativeProducts']: {
        path: 'alternative-products',
        name: 'Alternative Products',
    },
} as const

export const categoryPaths = Object.keys(categories).map(
    category => categories[category as keyof typeof categories].path
)

export type CategoryPath = (typeof categories)[keyof typeof categories]['path']
